import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class LocationsEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      id: null,
      logbook_external_id: null,
      name: null,
      icao_code: null,
      iata_code: null,
      city: null,
      coordinate_lat: null,
      coordinate_long: null,
      shore: null,
      location_type_id: null,
      base_id: null,
      class: null,
      group: null,
      country_id: null,
      location_types_select: [],
      countries_select: [],
      bases_select: [],
      syncingLogbook: false,
      syncButtonShake: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
    this.syncWithLogbook = this.syncWithLogbook.bind(this);

    this.syncShakeTimeout = null;
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  componentWillUnmount () {
    if (this.syncShakeTimeout) {
      clearTimeout(this.syncShakeTimeout);
      this.syncShakeTimeout = null;
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/local/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/locais');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            logbook_external_id: responseJson.data.main.logbook_external_id,
            name: responseJson.data.main.name,
            icao_code: responseJson.data.main.icao_code,
            iata_code: responseJson.data.main.iata_code,
            city: responseJson.data.main.city,
            coordinate_lat: responseJson.data.main.coordinate_lat,
            coordinate_long: responseJson.data.main.coordinate_long,
            shore: responseJson.data.main.shore,
            location_type_id: responseJson.data.main.location_type_id,
            class: responseJson.data.main.class,
            group: responseJson.data.main.group,
            country_id: responseJson.data.main.country_id,
            base_id: responseJson.data.main.base_id,
            location_types_select: responseJson.data.location_types_select,
            countries_select: responseJson.data.countries_select,
            bases_select: responseJson.data.bases_select,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      logbook_external_id: this.state.logbook_external_id,
      name: this.state.name,
      icao_code: this.state.icao_code,
      iata_code: this.state.iata_code,
      city: this.state.city,
      coordinate_lat: this.state.coordinate_lat,
      coordinate_long: this.state.coordinate_long,
      shore: this.state.shore,
      location_type_id: this.state.location_type_id,
      base_id: this.state.base_id,
      class: this.state.class,
      group: this.state.group,
      country_id: this.state.country_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/local', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var stateUpdates = { syncButtonShake: true };
          if (responseJson.data && typeof responseJson.data.logbook_external_id !== 'undefined') {
            stateUpdates.logbook_external_id = responseJson.data.logbook_external_id;
          }
          if (self.syncShakeTimeout) {
            clearTimeout(self.syncShakeTimeout);
            self.syncShakeTimeout = null;
          }
          self.setState(stateUpdates, () => {
            self.syncShakeTimeout = setTimeout(() => {
              self.setState({ syncButtonShake: false });
              self.syncShakeTimeout = null;
            }, 4000);
          });
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  syncWithLogbook(event) {
    event.preventDefault();
    if (!this.state.id || this.state.syncingLogbook) {
      return;
    }
    this.handleAlert('', '', 'open');
    this.setState({ syncingLogbook: true, syncButtonShake: false });

    var datasave = {
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/local/sync/logbook', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var syncState = { syncButtonShake: true };
          if (responseJson.data && typeof responseJson.data.logbook_external_id !== 'undefined') {
            syncState.logbook_external_id = responseJson.data.logbook_external_id;
          }
          if (self.syncShakeTimeout) {
            clearTimeout(self.syncShakeTimeout);
            self.syncShakeTimeout = null;
          }
          self.setState(syncState, () => {
            self.syncShakeTimeout = setTimeout(() => {
              self.setState({ syncButtonShake: false });
              self.syncShakeTimeout = null;
            }, 4000);
          });
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      }).then(() => {
        self.setState({ syncingLogbook: false });
      });
    });
  }


  render() {
    const syncButtonClass = `btn btn-warning logbook-sync-button${this.state.syncButtonShake ? ' logbook-sync-shake' : ''}`;
    const syncButtonIcon = this.state.syncingLogbook ? 'fa fa-spinner fa-pulse' : 'fa fa-refresh';
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Locais.EditarLocal.titulo}</h3>
      <div className="pull-right logbook-sync-actions">
        <button type="button" className={syncButtonClass} onClick={this.syncWithLogbook} disabled={this.state.syncingLogbook || !this.state.id}>
          <i className={syncButtonIcon}></i>{' Sincronizar com o Logbook App'}
        </button>
        <Link to="/locais" className="btn btn-default"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      </div>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Nome}:</label>
            <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.CodigoICAO}:</label>
            <input type="text" className="form-control" name="icao_code" value={this.state.icao_code} onChange={this.handleChange.bind(this, 'icao_code')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Cidade}:</label>
            <input type="text" className="form-control" name="city" value={this.state.city} onChange={this.handleChange.bind(this, 'city')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Shore}:</label>
            <Select
              className="form-field-name"
              name="shore"
              value={this.state.shore}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'shore')}
              options={[
                  {value: 'On-Shore', label: this.locale.Locais.EditarLocal.formulario.opcoesShore.OnShore},
                  {value: 'Off-Shore', label: this.locale.Locais.EditarLocal.formulario.opcoesShore.OffShore},
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Latitude}:</label>
            <input type="text" className="form-control" name="coordinate_lat" value={this.state.coordinate_lat} onChange={this.handleChange.bind(this, 'coordinate_lat')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Longitude}:</label>
            <input type="text" className="form-control" name="coordinate_long" value={this.state.coordinate_long} onChange={this.handleChange.bind(this, 'coordinate_long')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.CodigoIATA}:</label>
            <input type="text" name="iata_code" className="form-control" placeholder={this.locale.Locais.EditarLocal.formulario.placeholder.CodigoIATA} value={this.state.iata_code} onChange={this.handleChange.bind(this, 'iata_code')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Tipo}:</label>
            <Select
              className="form-field-name"
              name="location_type_id"
              value={this.state.location_type_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'location_type_id')}
              options={this.state.location_types_select}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Grupo}:</label>
            <Select
              className="form-field-name"
              name="group"
              value={this.state.group}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'group')}
              options={[
                {value: '1', label: '1'},
                {value: '2', label: '2'},
                {value: '3', label: '3'},
              ]}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Classe}:</label>
            <Select
              className="form-field-name"
              name="class"
              value={this.state.class}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'class')}
              options={[
                {value: 'A', label: 'A'},
                {value: 'B', label: 'B'},
                {value: 'C', label: 'C'},
                {value: 'D', label: 'D'},
                {value: 'E', label: 'E'},
                {value: 'F', label: 'F'},
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Base}:</label>
            <Select
              className="form-field-name"
              name="base_id"
              value={this.state.base_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'base_id')}
              options={this.state.bases_select}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Pais}:</label>
            <Select
              className="form-field-name"
              name="country_id"
              value={this.state.country_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'country_id')}
              options={this.state.countries_select}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>LogbookApp ID:</label>
            <input type="text" className="form-control" name="logbook_external_id" value={this.state.logbook_external_id} onChange={this.handleChange.bind(this, 'logbook_external_id')} />
          </div>
        </div>
        <hr/>
        <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvar}</button>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default LocationsEdit;



// WEBPACK FOOTER //
// ./src/Components/Locations/LocationsEdit.js